import { render, staticRenderFns } from "./CustomContainer.vue?vue&type=template&id=591f0bbd"
import script from "./CustomContainer.vue?vue&type=script&lang=ts"
export * from "./CustomContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports